/* ib2-body-en-ugc.js - EN body PDP "Loved by 100,000+" row = MAIN's Instant slider iGZNsS9RbFrFpUsNc
   (autoplay delay 1500 ms, speed 300 ms, loop, pause on mouse enter, 5px gap). Slides rotate: first slide moves to the end
   after each step, so the loop never rewinds. Row keys = the 3 EN contexts (uk / usa / usa-ca-nz-au). */
(() => {
  const row = document.querySelector('#ib2-body-post-purchase-00 :is([id$="__bc_651a2c82a28641"],[id$="__bc_25f2929f997da9"],[id$="__bc_71376e016b30ea"])');
  if (!row || row.children.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let hover = false, busy = false;
  row.addEventListener('mouseenter', () => { hover = true; });
  row.addEventListener('mouseleave', () => { hover = false; });
  setInterval(() => {
    if (hover || busy || document.hidden || row.scrollWidth <= row.clientWidth + 1) return;
    const first = row.firstElementChild;
    const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
    busy = true;
    for (const c of row.children) { c.style.transition = 'transform .3s ease'; c.style.transform = `translateX(${-step}px)`; }
    setTimeout(() => {
      for (const c of row.children) { c.style.transition = 'none'; c.style.transform = ''; }
      row.append(first);
      busy = false;
    }, 300);
  }, 1800);
})();

/* EN body gallery arrows + mouse drag (Pass 7) = MAIN's first Instant slider (S6eWnwTZ5idm1Iw3): prev/next buttons
   (MAIN's markup and icons), one slide per click, button disabled at either end; a mouse drag moves one slide when it is
   quick (< 300 ms) or longer than half a slide, as measured on MAIN; touch keeps the native scroll-snap swipe. Styles: ib2-body-en.css (en_hand_main.py). */
(() => {
  const box = document.getElementById('ib2-body-en-gallery'), sc = box && box.querySelector(':scope > .ib2-s__content');
  if (!sc || sc.children.length < 2 || box.querySelector(':scope > .ib2-gal-btn')) return;
  const btn = (dir, title, d) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = `ib2-gal-btn ib2-gal-btn--${dir}`;
    b.innerHTML = `<div class="ib2-gal-ic"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><title>${title}</title><path d="${d}"></path></svg></div>`;
    box.append(b); return b;
  };
  const prev = btn('prev', 'arrow-left', 'M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z');
  const next = btn('next', 'arrow-right', 'M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z');
  const w = () => sc.children[0].getBoundingClientRect().width || 1;
  const last = () => Math.round((sc.scrollWidth - sc.clientWidth) / w());
  const at = () => Math.round(sc.scrollLeft / w());
  let t = null, idle, x0 = null, s0 = 0, dx = 0, t0 = 0; // t = target slide while a click/drag animation runs
  const sync = () => { const i = t ?? at(); prev.disabled = i <= 0; next.disabled = i >= last(); };
  const go = i => { t = Math.max(0, Math.min(last(), i)); sc.scrollTo({ left: t * w(), behavior: 'smooth' }); sync(); };
  const settle = () => { t = null; if (x0 === null) sc.style.scrollSnapType = ''; sync(); };
  prev.addEventListener('click', () => go((t ?? at()) - 1));
  next.addEventListener('click', () => go((t ?? at()) + 1));
  sc.addEventListener('scroll', () => { clearTimeout(idle); idle = setTimeout(settle, 150); if (t === null) sync(); }, { passive: true });
  sc.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button) return;
    e.preventDefault(); x0 = e.clientX; s0 = sc.scrollLeft; dx = 0; t0 = e.timeStamp;
    sc.style.scrollSnapType = 'none'; sc.setPointerCapture(e.pointerId);
  });
  sc.addEventListener('pointermove', e => { if (x0 !== null) { dx = e.clientX - x0; sc.scrollLeft = s0 - dx; } });
  const end = e => {
    if (x0 === null) return;
    x0 = null; const i = Math.round(s0 / w()), d = Math.abs(dx);
    go(d > w() / 2 || (d > 10 && e.timeStamp - t0 < 300) ? i - Math.sign(dx) : i); clearTimeout(idle); idle = setTimeout(settle, 150);
  };
  sc.addEventListener('pointerup', end); sc.addEventListener('pointercancel', end);
  sync();
})();

/* EN body trust strip = MAIN's Instant ticker HfAxvUqIvSBQCCL9 (speed 90, not reversed, no pause): the items scroll left in an
   endless loop. Two tracks, each with ceil(strip width / group width) copies of the items; duration = copies x group width / 90 s,
   the way MAIN computes it. Clones are aria-hidden. Styles + keyframes: ib2-body-en.css (en_hand_main.py). */
(() => {
  const box = document.querySelector('#ib2-body-continuation-02 > .ib2-s__content > .ib2-group:first-child');
  if (!box || box.querySelector(':scope > .ib2-tk__t')) return;
  const grp = document.createElement('div'), t1 = document.createElement('div'), t2 = document.createElement('div');
  grp.className = 'ib2-tk__g'; grp.append(...box.children);
  t1.className = t2.className = 'ib2-tk__t'; t2.setAttribute('aria-hidden', 'true');
  t1.append(grp); box.classList.add('ib2-tk'); box.append(t1, t2);
  const copy = () => { const k = grp.cloneNode(true); k.setAttribute('aria-hidden', 'true'); return k; };
  let n = 0;
  const fit = () => {
    const gw = grp.getBoundingClientRect().width;
    if (!gw) return;
    const m = Math.min(8, Math.max(1, Math.ceil(box.clientWidth / gw))); // cap: a strip that sizes to its content must not clone forever
    if (m !== n) { n = m; t1.replaceChildren(grp, ...Array.from({ length: m - 1 }, copy)); t2.replaceChildren(...Array.from({ length: m }, copy)); }
    box.style.setProperty('--ib2-tk-dur', `${m * gw / 90}s`);
  };
  fit();
  const ro = new ResizeObserver(fit); ro.observe(box); ro.observe(grp);
})();
